/**
 * Premium "you've made the most of your companion" state — shown when a send is
 * blocked because the event's lifetime AI budget is spent (code 119011).
 *
 * Message only, no upgrade/payment CTA: the couple already owns Heirloom. Mirrors
 * AssistantUpsell's icon-tile aesthetic so the moment reads as one design system,
 * warm rather than a hard error.
 */

import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconifyIcon from 'components/base/IconifyIcon';

const AssistantExhaustedNotice = () => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="flex-start"
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: 'primary.lighter',
        border: '1px solid',
        borderColor: 'primary.light',
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <IconifyIcon icon="material-symbols:auto-awesome" sx={{ fontSize: 22 }} />
      </Box>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {t('assistant.exhausted.title')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('assistant.exhausted.body')}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AssistantExhaustedNotice;
